import { HttpStatusCode } from "axios";
import AppService from "../../apiServices/masters/appService";

import { setApp, setApps, setAppsForTerm } from "../../store/slices/master/appSlice";
import { alertConstants } from "../../helper/sweet-alert";

export function getApp(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await AppService.getApp(id);
    if (response?.success === true) {
      dispatch(setApp(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getApps(
  configUserRole?: number,
  pageBlockId?: number,
  collegeId?: number,
  noOfItems?: number
) {
  return async function (dispatch: any, getState: any) {
    let response = await AppService.getApps(
      configUserRole,
      pageBlockId,
      collegeId,
      noOfItems
    );
    if (response?.success === true) {
      if ((pageBlockId === 3 || pageBlockId === 7 || pageBlockId === 14 || pageBlockId === 11) && (collegeId == null || collegeId == undefined)) {
        dispatch(setAppsForTerm(response.data))
      }
      else {
        dispatch(setApps(response.data));
      }
    } else {
      console.log("error");
    }
  };
}

export function createApp(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await AppService.createApp(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        const name = data.get("name");
        callback(alertConstants.conflict, name);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateApp(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await AppService.updateApp(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      }
      else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateAppPriority(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await AppService.updateAppPriority(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}

export function deleteApp(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await AppService.deleteApp(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}
